module.exports = __webpack_public_path__ + "img/dg-youtube-playlist-white.66ff4f03.png";